import React from 'react';
import { Typography, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import FlexHeaderContainer from '../../../../components/containers/FlexHeaderContainer';

const Header = ({ onCreateNew }) => {
  return (
    <FlexHeaderContainer>
      <Typography variant="h4" component="h1" color="primary" fontWeight="bold">
        Practice Collections
      </Typography>
      
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={onCreateNew}
      >
        Create New Collection
      </Button>
    </FlexHeaderContainer>
  );
};

export default Header;
